import dayjs from 'dayjs'

import { ProDatetimePicker } from '@eastcoal/common/components/ProDatetimePicker'
import { ProDatetimePickerProps } from '@eastcoal/common/components/ProDatetimePicker/interface'

import { mapDateFormat } from '@eastcoal/formily/components/DatePicker/util'
import {
  connect,
  mapProps,
  mapReadPretty,
  useForm
} from '@eastcoal/formily/exports/react'

const simpleMode = {
  defaultEnable: true,
  hours: [8, 9, 10, 11, 14, 15, 16, 17, 18],
  minutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
}

const Component = ({ onChange, ...restPrpos }: ProDatetimePickerProps) => {
  const form = useForm()
  const handleDurationChange = (duration: number) => {
    const { startTime } = form.values
    const newValue = dayjs(startTime).add(duration, 'minute')
    onChange?.(newValue)
  }

  return (
    <ProDatetimePicker
      showNow={false}
      simpleMode={simpleMode}
      duration={{
        title: '距开始',
        onChange: handleDurationChange
      }}
      onChange={onChange}
      {...restPrpos}
    />
  )
}

export const EndTimePicker = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  }),
  mapProps(
    mapDateFormat({
      isRange: false,
      showTime: true
    })
  )
)
